import { useEffect, useMemo, useState } from 'react';

import { debounce } from 'lodash';

export const useSwingFilter = (onFilterUpdate?: () => void) => {
    const [filter, setFilter] = useState<string>('');
    const [filterQuery, setFilterQuery] = useState(filter);

    const updateFilterQuery = useMemo(() => {
        return debounce((value: string) => {
            setFilterQuery(value);
            onFilterUpdate?.();
        }, 500);
    }, [onFilterUpdate]);

    useEffect(() => {
        updateFilterQuery(filter);
    }, [filter, updateFilterQuery]);

    return [filter, setFilter, filterQuery] as const;
};
